<template>
    <main class="main" style="background-image: url('images/background.jpg');">
        <section v-if="ui.is_loading" class="loading-screen">
            <span class="loader"></span>
        </section>
        <section v-else class="form">

            <div class="form-wrapper">
                <div class="form_container">
                    <form @submit.stop.prevent="sendData" autocomplete="on">

                        <div class="left_inputs">
                            <div class="inputs">
                                <h1 class="title">Vous voulez acceder au METHODO ?</h1>
                                <p class="subtitle">Nous souhaitons quelques informations sur vous et votre organisme !</p>

                                <hr>

                                <div class="input_group" :class="{ invalid: errorEmail.has_error || errors.form_data.email }">
                                    <label> Adresse e-mail&nbsp;:</label>
                                    <input type="text" v-model.trim="form_data.email">
                                </div>

                                <div class="input_group" :class="{ invalid: errorType.has_error || errors.form_data.type }">
                                    <label> Vous êtes&nbsp;:</label>
                                    <select class="input" v-model="form_data.type">
                                        <!-- <option value="" selected disabled>Choisissez votre magasin</option> -->
                                        <option v-for="type in form_info.type" :value="type">{{ type }}</option>
                                    </select>
                                </div>

                                <div class="input_group" :class="{ invalid: errorOrganization.has_error || errors.form_data.organization }">
                                    <label> Organisme&nbsp;:</label>
                                    <input type="text" v-model.trim="form_data.organization">
                                </div>
                            </div>

                             <div v-if="ui.is_desktop_resolution" class="g-recaptcha" :data-sitekey="recaptcha_sitekey">
                            </div>

                            <div class="custom-checkboxs">
                                <label v-if="ui.is_desktop_resolution" class="checkbox-wrapper see_terms_btn">
                                    <input type="checkbox" v-model="form_data.newsletter_subscription">
                                    <span class="custom-checkmark"></span>
                                    <span class="tos_label">J'accepte de recevoir la newsletter mensuelle de l'Institut IDEAS</span>
                                </label>

                                <label v-if="ui.is_desktop_resolution" class="checkbox-wrapper see_terms_btn" :class="{ invalid: errors.form_data.ck_regulation }">
                                    <input type="checkbox" v-model="form_data.ck_regulation">
                                    <span class="custom-checkmark"></span>
                                    <span class="tos_label">L'Institut se conforme à la legislation RGPD. <a href="https://ideas.asso.fr/cgu/" style="color: #BB235F;" target="_blank">Voir les CGU</a></span>
                                </label>
                            </div>
                        </div>


                        <div class="right_inputs">
                            <div class="input_group" :class="{ invalid: errorDomain.has_error || errors.form_data.domain }">
                                <p style="font-size: 19px;"><b>Si vous êtes un organisme</b></p>
                                <label> Le domaine d'action principal de votre organisme&nbsp;:</label>
                                <select class="input" v-model="form_data.domain">
                                    <!-- <option value="" selected disabled>Choisissez votre magasin</option> -->
                                    <option v-for="domain in form_info.domain" :value="domain">{{ domain }}</option>
                                </select>
                            </div>

                            <div class="input_group" :class="{ invalid: errorLocation.has_error || errors.form_data.location }">
                                <label> Localisation du siège (code postal)&nbsp;:</label>
                                <input type="number" v-model.trim="form_data.location" @keydown="blockInvalidChars">
                            </div>

                            <div class="input_group" :class="{ invalid: errorOrganizationSeniority.has_error || errors.form_data.organization_seniority }">
                                <label> Ancienneté de l'organisme&nbsp;:</label>
                                <select class="input" v-model="form_data.organization_seniority">
                                    <!-- <option value="" selected disabled>Choisissez votre magasin</option> -->
                                    <option v-for="seniority in form_info.organization_seniority" :value="seniority">{{ seniority }}</option>
                                </select>
                            </div>

                            <div class="inputs_group">
                                <div class="input_group" :class="{ invalid: errorVolunteersNumber.has_error || errors.form_data.volunteers_number }">
                                    <label> Nombre de bénévoles&nbsp;:</label>
                                    <input type="number" v-model.trim="form_data.volunteers_number" @keydown="blockInvalidChars">
                                </div>

                                <div class="input_group" :class="{ invalid: errorEmployeesNumber.has_error || errors.form_data.employees_number }">
                                    <label> Nombre de salariés&nbsp;:</label>
                                    <input type="number" v-model.trim="form_data.employees_number" @keydown="blockInvalidChars">
                                </div>
                            </div>

                            <div class="input_group" :class="{ invalid: errorAnnualResources.has_error || errors.form_data.ammount_annual_resources }">
                                <label> Montant des ressources annuelles&nbsp;:</label>
                                <select class="input" v-model="form_data.ammount_annual_resources">
                                    <!-- <option value="" selected disabled>Choisissez votre magasin</option> -->
                                    <option v-for="ammount_annual_resources in form_info.ammount_annual_resources" :value="ammount_annual_resources">{{ ammount_annual_resources }}</option>
                                </select>
                            </div>

                            <div class="input_group" :class="{ invalid: errorRole.has_error || errors.form_data.role }">
                                <label> Votre rôle dans l'organisme :</label>
                                <select class="input" v-model="form_data.role">
                                    <!-- <option value="" selected disabled>Choisissez votre magasin</option> -->
                                    <option v-for="role in form_info.role" :value="role">{{ role }}</option>
                                </select>
                            </div>

                            <button v-if="ui.is_desktop_resolution" class="validation_btn" type="submit">ENVOYER</button>
                        </div>

                        <div class="custom-checkboxs">
                            <label v-if="ui.is_mobile_resolution" class="checkbox-wrapper see_terms_btn">
                                <input type="checkbox" v-model="form_data.newsletter_subscription">
                                <span class="custom-checkmark"></span>
                                <span class="tos_label">J'accepte de recevoir la newsletter mensuelle de l'Institut IDEAS</span>
                            </label>

                            <label v-if="ui.is_mobile_resolution" class="checkbox-wrapper see_terms_btn" :class="{ invalid: errors.form_data.ck_regulation }">
                                <input type="checkbox" v-model="form_data.ck_regulation">
                                <span class="custom-checkmark"></span>
                                <span class="tos_label">L'Institut se conforme à la legislation RGPD. <a href="https://ideas.asso.fr/cgu/" style="color: #BB235F;" target="_blank">Voir les CGU</a></span>
                            </label>
                        </div>


                        <div v-if="ui.is_mobile_resolution" class="g-recaptcha" :data-sitekey="recaptcha_sitekey">
                        </div>

                        <button v-if="ui.is_mobile_resolution" class="validation_btn" type="submit">ENVOYER</button>
                    </form>
                </div>
            </div>
            <img src="images/element.png" alt="element image">
        </section>

    </main>
</template>

<script>
import axios from 'axios';

export default {

    data: function () {
        return {
            ui: {
                is_loading: true,
                is_mobile_resolution: false,
                is_desktop_resolution: false,
                has_errors: false,
            },

            api_url: "api/controller/insert.php",
            recaptcha_sitekey: "6Lch0lksAAAAAOVyCkWp8hQDvV3FJ-LB-Qwsimmv",
            bearer_token: "Bearer WZIgw22bX9PMsQFXWphwgmZOtgYUbaYuU9HJgPRQT",

            form_data: {
                email: "",
                type: "",
                organization: "",
                location: "",
                domain: "",
                organization_seniority: "",
                volunteers_number: "",
                employees_number: "",
                ammount_annual_resources: "",
                role: "",
                newsletter_subscription: "",
                ck_regulation: "",
                recaptchaToken: "",
            },

            errors: {
                has_errors: false,
                form_data: {
                    email: false,
                    type: false,
                    organization: false,
                    location: false,
                    domain: false,
                    organization_seniority: false,
                    volunteers_number: false,
                    employees_number: false,
                    ammount_annual_resources: false,
                    role: false,
                    newsletter_subscription: false,
                    ck_regulation: false,
                }
            },

            errorEmail: {
                has_error: false,
            },
            errorType: {
                has_error: false,
            },
            errorDomain: {
                has_error: false,
            },
            errorOrganization: {
                has_error: false,
            },

            errorOrganizationSeniority: {
                has_error: false,
            },

            errorVolunteersNumber: {
                has_error: false,
            },

            errorEmployeesNumber: {
                has_error: false,
            },

            errorAnnualResources: {
                has_error: false,
            },

            errorRole: {
                has_error: false,
            },

            errorLocation: {
                has_error: false,
            },


            form_info: {
                type: [
                    'Association',
                    'Fondation / Fonds de dotation',
                    'Expert - Comptable',
                    'Commissaire aux Comptes',
                    'Consultant',
                    'Étudiant',
                    'Enseignant',
                    'Entreprise'
                ],
                domain: [
                    'Action sociale',
                    'Culture',
                    'Droits humains',
                    'Éducation',
                    'Environnement',
                    'Handicap',
                    'Recherche médicale',
                    'Santé',
                    'Solidarité internationale',
                    'Sports',
                    'Autres'
                ],
                organization_seniority: [
                    'En cours de création ou < 1an',
                    'De 1 à 5 ans',
                    'Plus de 5 ans'
                ],
                ammount_annual_resources: [
                    '< 10 000€',
                    'De 10 000 à 500 000€',
                    '> 500 000 €'
                ],
                role: [
                    'Président',
                    'Autre membre du conseil d’administration',
                    'Bénévole',
                    'Dirigeant(e) salarié(e)',
                    'Salarié(e)'
                ]
            },
        }
    },

    computed: {
        formValidity: function () {
            let self = this;

            var is_valid = true;

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!self.form_data.email) {
                self.errors.form_data.email = true;
                is_valid = false;
            } else if (!emailRegex.test(self.form_data.email)) {
                self.errors.form_data.email = true;
                is_valid = false;
            } else {
                self.errors.form_data.email = false;
            }

            if (!self.form_data.type) {
                self.errors.form_data.type = true;
                is_valid = false;
            } else {
                self.errors.form_data.type = false;
            }

            if (!self.form_data.organization) {
                self.errors.form_data.organization = true;
                is_valid = false;
            } else {
                self.errors.form_data.organization = false;
            }

            if (self.form_data.location === '' || self.form_data.location === null  || self.form_data.location === undefined) {
                self.errors.form_data.location = true;
                is_valid = false;
            } else {
                self.errors.form_data.location = false;
            }

            if (!self.form_data.domain) {
                self.errors.form_data.domain = true;
                is_valid = false;
            } else {
                self.errors.form_data.domain = false;
            }

            if (!self.form_data.organization_seniority) {
                self.errors.form_data.organization_seniority = true;
                is_valid = false;
            } else {
                self.errors.form_data.organization_seniority = false;
            }

            if (self.form_data.volunteers_number === '' || self.form_data.volunteers_number === null || self.form_data.volunteers_number === undefined) {
                self.errors.form_data.volunteers_number = true;
                is_valid = false;
            } else {
                self.errors.form_data.volunteers_number = false;
            }

            if (self.form_data.employees_number === '' || self.form_data.employees_number === null || self.form_data.employees_number === undefined) {
                self.errors.form_data.employees_number = true;
                is_valid = false;
            } else {
                self.errors.form_data.employees_number = false;
            }

            if (!self.form_data.ammount_annual_resources) {
                self.errors.form_data.ammount_annual_resources = true;
                is_valid = false;
            } else {
                self.errors.form_data.ammount_annual_resources = false;
            }

            if (!self.form_data.role) {
                self.errors.form_data.role = true;
                is_valid = false;
            } else {
                self.errors.form_data.role = false;
            }

            if (!self.form_data.ck_regulation) {
                self.errors.form_data.ck_regulation = true;
                is_valid = false;
            } else {
                self.errors.form_data.ck_regulation = false;
            }

            self.errors.has_errors = is_valid ? false : true;

            return is_valid;
        },
    },

    created() {
        let self = this;

        window.addEventListener("resize", self._onResize);
        self._updateResolutionType();

    },

    mounted() {
        let self = this;

        self.initRecaptchaScript();
        const isCompleted = localStorage.getItem('form_completed');

        if (isCompleted === 'true') {
            window.location.href = "https://methodo.ideas.asso.fr/catalogue/index.html";
        } else {
            self.ui.is_loading = false;
        }
    },

    beforeUnmount() {
        let self = this;

        window.removeEventListener("resize", self._onResize);
    },

    updated() {

    },
    methods: {
        blockInvalidChars(e) {
            if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                e.preventDefault()
            }
        },      
        resetErrors() {
            let self = this;

            self.errorEmail.has_error = false;
            self.errorType.has_error = false;
            self.errorOrganization.has_error = false;
            self.errorOrganizationSeniority.has_error = false;
            self.errorVolunteersNumber.has_error = false;
            self.errorEmployeesNumber.has_error = false;
            self.errorAnnualResources.has_error = false;
            self.errorRole.has_error = false;
            self.errorDomain.has_error = false;
            self.errorLocation.has_error = false;

            self.errors.form_data.email = false;
            self.errors.form_data.type = false;
            self.errors.form_data.organization = false;
            self.errors.form_data.location = false;
            self.errors.form_data.domain = false;
            self.errors.form_data.organization_seniority = false;
            self.errors.form_data.volunteers_number = false;
            self.errors.form_data.employees_number = false;
            self.errors.form_data.ammount_annual_resources = false;
            self.errors.form_data.role = false;

            self.errors.form_data.ck_regulation = false;
        },

        sendData() {
            let self = this;

            if (!self.formValidity) {
                return;
            }

            self.resetErrors();

            const form_data = new FormData();
            form_data.append('email', self.form_data.email);
            form_data.append('type', self.form_data.type);
            form_data.append('organization', self.form_data.organization);
            form_data.append('location', self.form_data.location);
            form_data.append('domain', self.form_data.domain);
            form_data.append('organization_seniority', self.form_data.organization_seniority);
            form_data.append('volunteers_number', self.form_data.volunteers_number);
            form_data.append('employees_number', self.form_data.employees_number);
            form_data.append('ammount_annual_resources', self.form_data.ammount_annual_resources);
            form_data.append('role', self.form_data.role);
            form_data.append('newsletter_subscription', self.form_data.newsletter_subscription ? 1 : 0);
            form_data.append('ck_regulation', self.form_data.ck_regulation ? 1 : 0);

            form_data.append('g-recaptcha-response', grecaptcha.getResponse());

            axios.post(self.api_url,
                form_data,
                {
                    headers: {
                        "Accept": "application/json",
                        'Content-Type': 'multipart/form-data',
                        'Authorization': self.bearer_token
                    }
                }

            ).then((response) => {
                localStorage.setItem('form_completed', 'true');
                localStorage.setItem('form_completion_date', new Date().toISOString());
                setTimeout(() => {
                    window.location.href = "https://methodo.ideas.asso.fr/catalogue/index.html";

                }, 1500);

            }).catch(error => {
                let error_response = '';
                if (error && error.response) {
                    error_response = error.response;
                }

                if (error.response.data.errors) {
                    self.errors.has_errors = true;

                    for (let k in error.response.data.errors) {
                        switch (k) {
                            case 'email':
                                self.errorEmail.has_error = true;
                                self.errorEmail.message = error.response.data.errors[k][0];
                                break;
                            case 'type':
                                self.errorType.has_error = true;
                                self.errorType.message = error.response.data.errors[k][0];
                                break;
                            case 'domain':
                                self.errorDomain.has_error = true;
                                self.errorDomain.message = error.response.data.errors[k][0];
                                break;
                            case 'organization_seniority':
                                self.errorOrganizationSeniority.has_error = true;
                                self.errorOrganizationSeniority.message = error.response.data.errors[k][0];
                                break;
                            case 'volunteers_number':
                                self.errorVolunteersNumber.has_error = true;
                                self.errorVolunteersNumber.message = error.response.data.errors[k][0];
                                break;
                            case 'employees_number':
                                self.errorEmployeesNumber.has_error = true;
                                self.errorEmployeesNumber.message = error.response.data.errors[k][0];
                                break;
                            case 'ammount_annual_resources':
                                self.errorAnnualResources.has_error = true;
                                self.errorAnnualResources.message = error.response.data.errors[k][0];
                                break;
                            case 'role':
                                self.errorRole.has_error = true;
                                self.errorRole.message = error.response.data.errors[k][0];
                                break;
                            case 'organization':
                                self.errorOrganization.has_error = true;
                                self.errorOrganization.message = error.response.data.errors[k][0];
                                break;
                            case 'location':
                                self.errorLocation.has_error = true;
                                self.errorLocation.message = error.response.data.errors[k][0];
                                break;
                        }
                    }
                    return;
                }
            });
        },

        initRecaptchaScript() {
            let self = this;


            // const recaptcha_sitekey = self.recaptcha_sitekey;
            // if (!recaptcha_sitekey) {
            //     return;
            // }

            const script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js'//?render=' + encodeURIComponent(recaptcha_sitekey);
            script.async = true;
            script.defer = true;

            script.onload = function () {
                console.log('reCAPTCHA v2 loaded');
            };

            document.head.appendChild(script);
        },


        _onResize: function () {
            var self = this;

            self._updateResolutionType();
        },

        _updateResolutionType: function () {

            var self = this;

            if (self.ui) {
                if (window.innerWidth > 1024) {
                    self.ui.is_mobile_resolution = false;
                    self.ui.is_desktop_resolution = true;
                } else {
                    self.ui.is_mobile_resolution = true;
                    self.ui.is_desktop_resolution = false;
                }
            }
        },
    }
};
</script>

<style lang="scss" scoped>
main {
    width: 100%;
    height: 100dvh;
    display: flex;
    color: #555555;
    font-family: 'Poppins', sans-serif;

    @media (max-width:1024px) {
        flex-direction: column;
    }

    section {
        width: 100%;
        height: 100%;
        display: block;

        &.form {
            justify-content: center;
            align-items: center;
            display: flex;
            flex-direction: column;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            &::before {
                content: "";
                position: absolute;
                width: 100%;
                height: 6px;
                background-color: #BB235F;
                top: 0;
                z-index: 1;
            }

            .custom-checkboxs {
                display: flex;
                flex-direction: column;
                gap: 10px;
                justify-content: center;
                width: fit-content;
            }

            .see_terms_btn {
                font-style: italic;
                width: fit-content;
                font-size: 15px;
                cursor: pointer;

                a {
                    text-decoration: unset;
                    font-weight: bold;
                }

                &.checkbox-wrapper {
                    position: relative;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    cursor: pointer;
                    color: #BB235F;

                    @media (max-width: 1023px) {
                        width: 100%;
                    }

                    &.invalid {
                        .tos_label {
                            color: red;

                            a {
                                color: red !important;
                            }
                        }
                    }
                }

                &.checkbox-wrapper input[type="radio"],
                &.checkbox-wrapper input[type="checkbox"] {
                    position: absolute;
                    opacity: 0;
                    width: 0;
                    height: 0;
                }

                .custom-checkmark {
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    background: #fff;
                    border: 1px solid #555555;
                    position: relative;
                    flex-shrink: 0;
                }

                &.checkbox-wrapper input[type="radio"]:checked+.custom-checkmark::after,
                &.checkbox-wrapper input[type="checkbox"]:checked+.custom-checkmark::after {
                    content: "";
                    position: absolute;
                    left: 4px;
                    top: -3px;
                    width: 10px;
                    height: 19px;
                    border: solid #BB235F;
                    border-width: 0px 2px 2px 0;
                    transform: rotate(45deg);
                }

                &.checkbox-wrapper span {
                    font-weight: 400;
                    font-size: 14px;
                    color: #555555;
                    text-align: left;
                }

            }

            .validation_btn {
                font-size: 15px;
                font-weight: 700;
                padding: 10px 40px;
                background-color: #BB235F;
                color: #fff;
                width: 100%;
                text-transform: uppercase;
                cursor: pointer;

                &:disabled {
                    background-color: #ababad;
                    box-shadow: 0 7px 11px -3px grey;
                }
            }

            img {
                position: absolute;
                z-index: -1;
                bottom: 0;
                width: 200px;
                right: 0;
            }
        }
    }

    .form {
        height: 100%;
        position: relative;
        background: #fff;
        max-width: 90%;
        max-height: 90%;
        display: flex;
        align-items: center;
        justify-content: center;

        @media (max-width:1024px) {
            width: 100%;
            height: unset;
            overflow-y: auto;
        }

        .form-wrapper {
            height: calc(100% - 60px);
            width: 100%;
            overflow-y: auto;

            @media (max-width:1024px) {
                height: unset;
            }
        }

        .form_container {
            display: flex;
            // flex-direction: column;
            justify-content: space-between;
            width: 100%;
            // position: absolute;
            // top: 50%;
            // left: 50%;
            // transform: translate(-50%, -50%);

            // overflow-x: hidden;
            padding: 30px;



            h1 {
                font-size: 24px;
                margin-bottom: 20px;

                @media (max-width:1024px) {
                    margin-bottom: 10px;
                }
            }

            p.subtitle {
                font-size: 24px;
            }

            hr {
                margin: 12px 0;
                width: 100%;
                border-top: 1px solid #555555;

                @media (max-width:1024px) {
                    margin: 9px 0;
                }
            }

            .left_inputs,
            .right_inputs {
                display: flex;
                flex-direction: column;
                width: 49%;
                gap: 20px;

                justify-content: space-between;
                height: 100%;

                @media (max-width:1024px) {
                    width: 100%;
                }

                .inputs_group {
                    display: flex;
                    width: 100%;
                    gap: 20px;

                    @media (max-width: 1024px) {
                        flex-direction: column;
                    }
                }

                .inputs {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                }
            }

            .right_inputs {
                @media (max-width: 1024px) {
                    height: unset;
                }
            }
        }

        form {
            display: flex;
            justify-content: space-between;
            gap: 40px;
            width: 100%;

            @media (max-width: 1024px) {
                flex-direction: column;
                gap: 15px;
            }

            .input_group {
                display: flex;
                flex-direction: column;
                position: relative;
                width: 100%;

                &.invalid {

                    input,
                    textarea {
                        border: 1px solid red;
                    }

                    label {
                        color: red !important;
                    }

                    select {
                        border: 1px solid red;
                    }

                    p {
                        color: red;
                    }
                }

                label {
                    font-size: 19px;
                    margin-bottom: 5px;
                }

                select,
                input {
                    border: 1px solid #dfe2e6;
                    width: 100%;
                    padding: 5px 10px;
                    height: 49px;
                    font-size: 16px;
                    color: #555555;
                    background: transparent;

                    @media (max-width:1024px) {
                        width: 100%;
                    }

                    option {
                        width: 100%;
                        color: #555555;
                    }

                }

                input:focus-visible,
                select:focus-visible {
                    outline: unset;

                }

                input::-webkit-outer-spin-button,
                input::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }

                input[type=number] {
                    -moz-appearance: textfield;
                }

                select {
                    color: #555555;
                    padding-right: 53px;

                    option {
                        color: #000;
                    }
                }

                // [type="checkbox"]:not(:checked)+label:before {
                //     border: 1px solid #6b6c6f;
                // }

                // [type="checkbox"]:not(:checked)+label:after {
                //     border: 1px solid #6b6c6f;
                // }


                // [type="checkbox"]:disabled:not(:checked)+label:hover:before {
                //     border-color: #6b6c6f;
                // }

                select {
                    -moz-appearance: none;
                    -webkit-appearance: none;
                    appearance: none;
                    position: relative;
                    background: transparent;
                    background-image: url("@/assets/images/arrow_down.png");
                    background-size: 24px auto;
                    background-repeat: no-repeat;
                    background-position-x: 98%;
                    background-position-y: 17px;
                    // position: absolute;
                    // top: 0;
                    // width: 20px;
                    // height: auto;
                    // display: block;
                }

                p {
                    font-size: 14px;
                    font-weight: 400;
                    margin-bottom: 7px;
                }

                &.checkbox {
                    flex-direction: row;
                    gap: 10px;

                    input {
                        width: fit-content;
                    }

                    label {
                        font-size: 15px;
                        font-weight: 500;
                        color: #ababad;
                    }
                }
            }
        }
    }

    .loading-screen {
        background-color: #fff;
    }

    .loader {
        width: 48px;
        height: 48px;
        border: 5px solid #555555;
        border-bottom-color: transparent;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
        position: absolute;
        top: 50%;
        left: 50%;
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
}
</style>
